/**
 * @author JuanFuent.es
 * @desc Imprime en consola del browser créditos
 * @param { String } Message
 */
export default class Credits {
    constructor(msg = "Lorem Credits") {
        this.msg = [
            `%c %c ${msg.toUpperCase()} `,
            'background: #fdc100; padding: 5px 0;',
            'font-family: sans-serif; font-weight: bold; color: #fdc100; background: #000; padding: 5px 5px 5px 5px;'
        ]
        this.craft = [
            "%c %c https://juanfuent.es | Digital Arts & Crafts",
            'background: #fdc100; color: #f23b22; padding: 5px 0;',
            'font-family: monospace; color: #fdc100; background: #101010; padding: 5px 5px 5px 5px;'
        ]
        this.roll()
    }
    
    roll() {
        console.log.apply(console, this.msg)
        console.log.apply(console, this.craft)
    }
}